const roles = {
  homePage: {
    roles: ['admin']
  }
}

export default roles
